import React from 'react'
import { useLocation } from 'react-router-dom'
import { useLanguage, useLanguageFlags } from '@chilecompra/react-kit/i18n'
import NotFoundPage from '../pages/NotFound'
import WizardLayout from '../components/Layouts/WizardLayout'
import ProtectByFeatures from '../components/Security/ProtectByFeatures'
import AuthenticationContainer from '../containers/AuthenticationProvider/AuthenticationProvider.container'
import RegisterWizardWelcomeContainer from '../containers/RegisterWizard/RegisterWizardWelcome.container'
import RegisterWizardForeignPersonalInformationContainer from '../containers/RegisterWizard/RegisterWizardForeignPersonalInformation.container'
import RegisterWizardBusinessAreasContainer from '../containers/RegisterWizard/RegisterWizardBusinessAreas.container'
import RegisterWizardForeignBusinessInformationContainer from '../containers/RegisterWizard/RegisterWizardForeignBusinessInformation.container'
import RegisterWizardCompleteContainer from '../containers/RegisterWizard/RegisterWizardComplete.container'
import RegisterWizardEmailVerifyContainer from '../containers/RegisterWizard/RegisterWizardEmailVerify.container'
import RegisterWizardPasswordGenerationContainer from '../containers/RegisterWizard/RegisterWizardPasswordGeneration.container'
import {
  BusinessIcon,
  BusinessCenterIcon,
  CheckIcon,
  LockIcon,
  MailIcon,
  PersonIcon
} from './ForeignRegisterWizard.styles'

/**
 * The ForeignRegisterWizard' page.
 */
const ForeignRegisterWizard = () => {
  const location = useLocation()
  const { language } = useLanguage()
  const { isLanguageES } = useLanguageFlags()
  const { state } = location

  return (
    <ProtectByFeatures fallback={() => <NotFoundPage />} rule={features => features['com.seller/foreign.enrollment']}>
      <AuthenticationContainer>
        <WizardLayout
          defaultStepID={state?.defaultStepID || 'welcome'}
          steps={[
            {
              component: <RegisterWizardWelcomeContainer />,
              id: 'welcome',
              number: 0,
              showNumber: false,
              showStep: false
            },
            {
              component: <RegisterWizardForeignPersonalInformationContainer />,
              icon: <PersonIcon size="1.5em" />,
              id: 'personal-info',
              name: language('RegisterWizardForeignPersonalInformation__stepName'),
              number: 1,
              showNumber: true,
              showStep: true
            },
            {
              component: <RegisterWizardEmailVerifyContainer />,
              icon: <MailIcon size="1.3em" />,
              id: 'email-verify',
              name: language('RegisterWizardEmailVerify__stepName'),
              number: 2,
              showNumber: true,
              showStep: true
            },
            {
              component: <RegisterWizardPasswordGenerationContainer />,
              icon: <LockIcon size="1.3em" />,
              id: 'password-generation',
              name: language('RegisterWizardPasswordGeneration__stepName'),
              number: 3,
              showNumber: true,
              showStep: true
            },
            {
              component: <RegisterWizardForeignBusinessInformationContainer />,
              icon: <BusinessIcon size="1.3em" />,
              id: 'business-info',
              name: language('RegisterWizardForeignBusinessInformation__stepName'),
              number: 4,
              showNumber: true,
              showStep: true
            },
            isLanguageES && {
              component: <RegisterWizardBusinessAreasContainer />,
              icon: <BusinessCenterIcon size="1.3em" />,
              id: 'business-areas',
              name: 'Agregar rubros',
              number: 5,
              showNumber: true,
              showStep: true
            },
            {
              component: <RegisterWizardCompleteContainer />,
              icon: <CheckIcon size="1.3em" />,
              id: 'complete',
              name: language('RegisterWizardComplete__stepName'),
              number: 6,
              showNumber: false,
              showStep: true
            }
          ].filter(Boolean)}
        />
      </AuthenticationContainer>
    </ProtectByFeatures>
  )
}

export default ForeignRegisterWizard
